import { render, staticRenderFns } from "./LabelPersonalizado.vue?vue&type=template&id=0d8d27e6&"
import script from "./LabelPersonalizado.vue?vue&type=script&lang=js&"
export * from "./LabelPersonalizado.vue?vue&type=script&lang=js&"
import style0 from "./LabelPersonalizado.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports